var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcess3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 132,
    viewBox: "0 0 179 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 132,
    rx: 19,
    fill: "#F5FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.141 20H42.87C40.7847 20 38.7846 20.8277 37.309 22.3012C35.8334 23.7748 35.0029 25.7737 35 27.8591V100.15C35.0029 102.235 35.8334 104.234 37.309 105.707C38.7846 107.181 40.7847 108.009 42.87 108.009H55.2624C55.6758 108.009 56.0722 107.844 56.3645 107.552C56.6568 107.26 56.821 106.863 56.821 106.45C56.821 106.037 56.6568 105.64 56.3645 105.348C56.0722 105.056 55.6758 104.891 55.2624 104.891H42.87C41.6114 104.891 40.4042 104.392 39.5132 103.503C38.6222 102.614 38.1202 101.408 38.1173 100.15V40.1636H112.757C113.17 40.1636 113.566 39.9994 113.859 39.7071C114.151 39.4148 114.315 39.0183 114.315 38.605C114.315 38.1916 114.151 37.7951 113.859 37.5028C113.566 37.2105 113.17 37.0463 112.757 37.0463H38.1173V27.8591C38.1231 26.6014 38.626 25.397 39.5164 24.5087C40.4068 23.6203 41.6123 23.1202 42.87 23.1173H132.141C133.399 23.1173 134.605 23.6169 135.494 24.5061C136.383 25.3954 136.883 26.6015 136.883 27.8591V37.1012H117.97C117.557 37.1012 117.161 37.2654 116.868 37.5577C116.576 37.85 116.412 38.2465 116.412 38.6598C116.412 39.0732 116.576 39.4697 116.868 39.762C117.161 40.0543 117.557 40.2185 117.97 40.2185H136.883V100.204C136.884 100.827 136.763 101.445 136.525 102.021C136.287 102.597 135.938 103.12 135.497 103.561C135.056 104.001 134.533 104.35 133.957 104.588C133.381 104.826 132.764 104.948 132.141 104.946H60.4652C60.0518 104.946 59.6553 105.11 59.363 105.403C59.0707 105.695 58.9065 106.091 58.9065 106.505C58.9065 106.918 59.0707 107.315 59.363 107.607C59.6553 107.899 60.0518 108.063 60.4652 108.063H132.141C133.173 108.065 134.196 107.863 135.15 107.468C136.104 107.074 136.971 106.495 137.701 105.765C138.431 105.035 139.01 104.168 139.405 103.214C139.799 102.259 140.001 101.237 140 100.204V27.8591C140 25.7747 139.172 23.7757 137.698 22.3019C136.224 20.828 134.225 20 132.141 20Z",
    fill: "url(#paint0_linear_0_627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.915 30.0763C41.915 31.1618 42.2369 32.2229 42.8399 33.1254C43.443 34.0279 44.3001 34.7314 45.3029 35.1468C46.3058 35.5621 47.4093 35.6708 48.4739 35.4591C49.5385 35.2473 50.5164 34.7246 51.2839 33.9571C52.0514 33.1895 52.5741 32.2116 52.7859 31.147C52.9977 30.0824 52.889 28.9789 52.4736 27.9761C52.0582 26.9733 51.3548 26.1161 50.4523 25.5131C49.5497 24.91 48.4886 24.5881 47.4032 24.5881C45.9476 24.5881 44.5517 25.1664 43.5224 26.1956C42.4932 27.2248 41.915 28.6208 41.915 30.0763ZM49.818 30.0763C49.8201 30.5491 49.6822 31.0119 49.4215 31.4064C49.1609 31.8008 48.7892 32.1092 48.3534 32.2926C47.9177 32.4761 47.4374 32.5263 46.9731 32.437C46.5088 32.3476 46.0814 32.1228 45.7448 31.7908C45.4082 31.4588 45.1775 31.0345 45.0818 30.5715C44.9861 30.1085 45.0297 29.6275 45.2072 29.1893C45.3846 28.751 45.6879 28.3752 46.0787 28.1091C46.4695 27.8431 46.9304 27.6988 47.4032 27.6945C47.7169 27.693 48.0278 27.7535 48.318 27.8726C48.6083 27.9917 48.8722 28.1669 49.0945 28.3882C49.3169 28.6095 49.4933 28.8726 49.6136 29.1623C49.734 29.452 49.796 29.7626 49.796 30.0763",
    fill: "url(#paint1_linear_0_627)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6118 30.0763C66.6118 31.1618 66.9337 32.2229 67.5367 33.1254C68.1398 34.0279 68.9969 34.7314 69.9998 35.1468C71.0026 35.5621 72.1061 35.6708 73.1707 35.4591C74.2353 35.2473 75.2132 34.7246 75.9807 33.9571C76.7483 33.1895 77.271 32.2116 77.4827 31.147C77.6945 30.0824 77.5858 28.9789 77.1704 27.9761C76.755 26.9733 76.0516 26.1161 75.1491 25.5131C74.2466 24.91 73.1855 24.5881 72.1 24.5881C70.6444 24.5881 69.2485 25.1664 68.2193 26.1956C67.19 27.2248 66.6118 28.6208 66.6118 30.0763ZM74.5038 30.0763C74.506 30.5505 74.3672 31.0147 74.1051 31.4098C73.8431 31.805 73.4694 32.1134 73.0318 32.2959C72.5941 32.4783 72.112 32.5267 71.6469 32.4347C71.1817 32.3427 70.7543 32.1146 70.419 31.7793C70.0837 31.444 69.8556 31.0166 69.7636 30.5514C69.6716 30.0862 69.7199 29.6042 69.9024 29.1665C70.0849 28.7288 70.3933 28.3552 70.7885 28.0931C71.1836 27.8311 71.6478 27.6923 72.1219 27.6945C72.4347 27.6945 72.7445 27.7561 73.0335 27.8758C73.3225 27.9955 73.585 28.1709 73.8062 28.3921C74.0274 28.6133 74.2028 28.8758 74.3225 29.1648C74.4422 29.4538 74.5038 29.7635 74.5038 30.0763Z",
    fill: "url(#paint2_linear_0_627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2414 30.0763C54.2414 31.1618 54.5632 32.2229 55.1663 33.1254C55.7693 34.0279 56.6265 34.7314 57.6293 35.1468C58.6321 35.5621 59.7356 35.6708 60.8002 35.4591C61.8648 35.2473 62.8427 34.7246 63.6103 33.9571C64.3778 33.1895 64.9005 32.2116 65.1123 31.147C65.3241 30.0824 65.2154 28.9789 64.8 27.9761C64.3846 26.9733 63.6811 26.1161 62.7786 25.5131C61.8761 24.91 60.815 24.5881 59.7296 24.5881C58.274 24.5881 56.878 25.1664 55.8488 26.1956C54.8196 27.2248 54.2414 28.6208 54.2414 30.0763ZM62.1334 30.0763C62.1356 30.5505 61.9968 31.0147 61.7347 31.4098C61.4726 31.805 61.099 32.1134 60.6613 32.2959C60.2236 32.4783 59.7416 32.5267 59.2764 32.4347C58.8112 32.3427 58.3838 32.1146 58.0485 31.7793C57.7132 31.444 57.4851 31.0166 57.3932 30.5514C57.3012 30.0862 57.3495 29.6042 57.5319 29.1665C57.7144 28.7288 58.0228 28.3552 58.418 28.0931C58.8131 27.8311 59.2773 27.6923 59.7515 27.6945C60.3832 27.6945 60.989 27.9454 61.4357 28.3921C61.8824 28.8388 62.1334 29.4446 62.1334 30.0763Z",
    fill: "url(#paint3_linear_0_627)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9804 99.6666V44.5652C70.9804 44.1518 70.8162 43.7554 70.5239 43.463C70.2316 43.1707 69.8352 43.0065 69.4218 43.0065H43.4297C43.0249 43.0207 42.6413 43.1908 42.359 43.4813C42.0767 43.7718 41.9176 44.1601 41.915 44.5652V99.6666C41.9179 100.079 42.083 100.474 42.3747 100.766C42.6663 101.057 43.0611 101.222 43.4736 101.225H69.4657C69.8782 101.222 70.273 101.057 70.5646 100.766C70.8563 100.474 71.0214 100.079 71.0243 99.6666H70.9804ZM67.8631 98.1079H44.9884V46.1238H67.8631V98.1079Z",
    fill: "url(#paint4_linear_0_627)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4798 69.5035H131.57C131.776 69.5049 131.98 69.4657 132.17 69.388C132.36 69.3103 132.534 69.1958 132.68 69.0509C132.825 68.906 132.941 68.7337 133.02 68.5439C133.099 68.354 133.14 68.1505 133.14 67.9449V44.5652C133.137 44.1527 132.972 43.7579 132.68 43.4662C132.389 43.1745 131.994 43.0094 131.581 43.0065H76.4798C76.2752 43.0065 76.0725 43.0468 75.8834 43.1252C75.6943 43.2035 75.5224 43.3183 75.3777 43.463C75.233 43.6078 75.1182 43.7796 75.0399 43.9687C74.9615 44.1578 74.9212 44.3605 74.9212 44.5652V67.9449C74.9198 68.1499 74.9591 68.3533 75.0369 68.543C75.1147 68.7328 75.2294 68.9052 75.3745 69.0502C75.5195 69.1953 75.6919 69.31 75.8816 69.3878C76.0714 69.4656 76.2747 69.505 76.4798 69.5035ZM78.0385 46.1238H130.012V66.3862H78.0385V46.1238Z",
    fill: "url(#paint5_linear_0_627)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9212 99.6666C74.9212 99.8713 74.9615 100.074 75.0399 100.263C75.1182 100.452 75.233 100.624 75.3777 100.769C75.5224 100.913 75.6943 101.028 75.8834 101.107C76.0725 101.185 76.2752 101.225 76.4798 101.225H131.57C131.985 101.225 132.382 101.061 132.676 100.769C132.97 100.477 133.137 100.081 133.14 99.6666V76.2869C133.14 75.8735 132.976 75.4771 132.683 75.1848C132.391 74.8925 131.995 74.7282 131.581 74.7282H76.4798C76.2747 74.7268 76.0714 74.7661 75.8816 74.8439C75.6919 74.9217 75.5195 75.0365 75.3745 75.1815C75.2294 75.3265 75.1147 75.4989 75.0369 75.6887C74.9591 75.8785 74.9198 76.0818 74.9212 76.2869V99.6666ZM78.0385 77.8455H130.012V98.1079H78.0385V77.8455Z",
    fill: "url(#paint6_linear_0_627)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8728 54.5426H62.9786C63.392 54.5426 63.7884 54.3784 64.0807 54.0861C64.373 53.7938 64.5372 53.3974 64.5372 52.984C64.5372 52.5706 64.373 52.1742 64.0807 51.8819C63.7884 51.5896 63.392 51.4254 62.9786 51.4254H49.8728C49.4594 51.4254 49.063 51.5896 48.7707 51.8819C48.4784 52.1742 48.3141 52.5706 48.3141 52.984C48.3141 53.3974 48.4784 53.7938 48.7707 54.0861C49.063 54.3784 49.4594 54.5426 49.8728 54.5426Z",
    fill: "url(#paint7_linear_0_627)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8728 63.9275H62.9786C63.392 63.9275 63.7884 63.7633 64.0807 63.471C64.373 63.1787 64.5372 62.7822 64.5372 62.3688C64.5372 61.9554 64.373 61.559 64.0807 61.2667C63.7884 60.9744 63.392 60.8102 62.9786 60.8102H49.8728C49.4594 60.8102 49.063 60.9744 48.7707 61.2667C48.4784 61.559 48.3141 61.9554 48.3141 62.3688C48.3141 62.7822 48.4784 63.1787 48.7707 63.471C49.063 63.7633 49.4594 63.9275 49.8728 63.9275Z",
    fill: "url(#paint8_linear_0_627)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8728 73.3233H62.9786C63.392 73.3233 63.7884 73.1591 64.0807 72.8668C64.373 72.5745 64.5372 72.178 64.5372 71.7646C64.5372 71.3513 64.373 70.9548 64.0807 70.6625C63.7884 70.3702 63.392 70.206 62.9786 70.206H49.8728C49.4594 70.206 49.063 70.3702 48.7707 70.6625C48.4784 70.9548 48.3141 71.3513 48.3141 71.7646C48.3141 72.178 48.4784 72.5745 48.7707 72.8668C49.063 73.1591 49.4594 73.3233 49.8728 73.3233Z",
    fill: "url(#paint9_linear_0_627)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8727 82.6971H62.9785C63.3707 82.6642 63.7363 82.4851 64.0027 82.1954C64.2691 81.9057 64.417 81.5265 64.417 81.1329C64.417 80.7393 64.2691 80.3601 64.0027 80.0704C63.7363 79.7807 63.3707 79.6017 62.9785 79.5688H49.8727C49.4805 79.6017 49.115 79.7807 48.8486 80.0704C48.5821 80.3601 48.4343 80.7393 48.4343 81.1329C48.4343 81.5265 48.5821 81.9057 48.8486 82.1954C49.115 82.4851 49.4805 82.6642 49.8727 82.6971Z",
    fill: "url(#paint10_linear_0_627)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8728 92.0709H62.9786C63.392 92.0709 63.7884 91.9067 64.0807 91.6144C64.373 91.3221 64.5372 90.9256 64.5372 90.5123C64.5372 90.0989 64.373 89.7024 64.0807 89.4101C63.7884 89.1178 63.392 88.9536 62.9786 88.9536H49.8728C49.4594 88.9536 49.063 89.1178 48.7707 89.4101C48.4784 89.7024 48.3141 90.0989 48.3141 90.5123C48.3141 90.9256 48.4784 91.3221 48.7707 91.6144C49.063 91.9067 49.4594 92.0709 49.8728 92.0709Z",
    fill: "url(#paint11_linear_0_627)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22H33C41.2843 22 48 15.2843 48 7V0H15C6.71573 0 0 6.71573 0 15V22Z",
    fill: "#044D66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131 132H164C172.284 132 179 125.284 179 117V110H146C137.716 110 131 116.716 131 125V132Z",
    fill: "#044D66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_627",
    x1: 87.5,
    y1: 20,
    x2: 87.5,
    y2: 108.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_627",
    x1: 47.3702,
    y1: 24.5772,
    x2: 47.3702,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_627",
    x1: 72.122,
    y1: 24.5772,
    x2: 72.122,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_627",
    x1: 59.7405,
    y1: 24.5772,
    x2: 59.7405,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_627",
    x1: 56.4257,
    y1: 43.0065,
    x2: 56.4257,
    y2: 101.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_627",
    x1: 104.031,
    y1: 43.0065,
    x2: 104.031,
    y2: 69.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_627",
    x1: 104.031,
    y1: 74.7282,
    x2: 104.031,
    y2: 101.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_627",
    x1: 56.4257,
    y1: 51.4254,
    x2: 56.4257,
    y2: 54.5426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_627",
    x1: 56.4257,
    y1: 60.8102,
    x2: 56.4257,
    y2: 63.9275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_627",
    x1: 56.4257,
    y1: 70.195,
    x2: 56.4257,
    y2: 73.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_627",
    x1: 56.4256,
    y1: 79.5688,
    x2: 56.4256,
    y2: 82.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_627",
    x1: 56.4257,
    y1: 88.9536,
    x2: 56.4257,
    y2: 92.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDC84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C6C45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess3);
export default __webpack_public_path__ + "static/media/process-3.435bf4aa.svg";
export { ForwardRef as ReactComponent };